import Row from "@amzn/meridian/row";
import Loader from "@amzn/meridian/loader";
import React, {useEffect, useReducer} from "react";
import Alert from "@amzn/meridian/alert";
import Column from "@amzn/meridian/column";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import Button from "@amzn/meridian/button";
import {EwayBillReducer} from "./reducer/EwayBillReducer";
import Table, {TableCell, TableRow} from "@amzn/meridian/table";
import {EwayBillActions} from "./actions/EwayBillActions";
import {CSVLink} from "react-csv";
import {csvFileName} from "./constants/EwayBillErrorMessages";
import AppNotification from "./constants/AppNotification";
import PhoneTool from "../util/PhoneTool";
import {getCSVdata, maskLmVRID} from "../util/EwayBillUtils";

const LMVRID_ATTRIBUTES = [
    ["LMVRID", {stringId: "lmVRID"}],
    ["LAST_UPDATED_BY", {stringId: "lastUpdatedBy"}],
    ["LAST_UPDATED_TIME", {stringId: "lastUpdatedTime"}]

];

const initialState = {
    lmVRIDs: [],
    loading: false,
    success: true,
    errorMessage: "",
    downloadEwayBillFailure: false
};

export const EwayBill = (props) => {

    const [{lmVRIDs, loading, success, errorMessage, downloadEwayBillFailure}, dispatch] = useReducer(EwayBillReducer, initialState);
    const csvLink = React.useRef();


    useEffect(() => {
        dispatch({
            type: EwayBillActions.FETCH_LMVRID_DETAILS,
            dispatcher: dispatch
        })
    }, []);

    if (loading) {
        return (<Row alignmentHorizontal="center" alignmentVertical="center" height="100%" minHeight="460px">
            <Loader type="circular"/>
        </Row>)
    }

    if (!success && !downloadEwayBillFailure) {
        return (
            <Column spacingInset="small large">
            <Box>
                <Row width="100%" widths="fill" spacing="medium" spacingInset="medium">
                    <Column>
                        <Text type="h600"><FormattedMessage id="print.lmvrid_details" defaultMessage="LM-VRID Details"/></Text>
                    </Column>
                    <Column>
                        <Row alignmentHorizontal="right">
                            <Button disabled='true' type="tertiary">
                                <FormattedMessage id="print.export_to_csv" defaultMessage="Export to CSV"/></Button>
                        </Row>
                    </Column>
                </Row>
                <Table headerRows={1} spacing="small" showStripes={true}>
                    <HeaderRow/>
                </Table>
                <Row alignmentHorizontal="center" alignmentVertical="center" height="100%" minHeight="460px">
                    <Alert type="error">{errorMessage}</Alert>
                </Row>
            </Box>
            </Column>
        )
    }

    if (success && !loading && lmVRIDs.length === 0) {
        return (
            <Column spacingInset="small large">
            <Box>
                <Row width="100%" widths="fill" spacing="medium" spacingInset="medium">
                    <Column>
                        <Text type="h600"><FormattedMessage id="print.lmvrid_details" defaultMessage="LM-VRID Details"/></Text>
                    </Column>
                    <Column>
                        <Row alignmentHorizontal="right">
                            <Button disabled='true' type="tertiary">
                                <FormattedMessage id="print.export_to_csv" defaultMessage="Export to CSV"/></Button>
                        </Row>
                    </Column>
                </Row>
                <Table headerRows={1} spacing="small" showStripes={true}>
                    <HeaderRow/>
                </Table>
            <Row alignmentHorizontal="center" alignmentVertical="center" height="100%" minHeight="460px">
            <Alert type="informational">
                <FormattedMessage id="print.no_active_lmvrid" defaultMessage="No active LM-VRID found for the station"/>
            </Alert>
            </Row>
            </Box>
            </Column>
        )
    }

    if (!success && downloadEwayBillFailure) {
        return (
            <Column spacingInset="small large">
            <Box>
                <Row width="100%" widths="fill" spacing="medium" spacingInset="medium">
                    <Column>
                        <Text type="h600"><FormattedMessage id="print.lmvrid_details" defaultMessage="LM-VRID Details"/></Text>
                    </Column>
                    <Column>
                        <Row alignmentHorizontal="right">
                            <Button disabled='true' type="tertiary">
                                <FormattedMessage id="print.export_to_csv" defaultMessage="Export to CSV"/></Button>
                        </Row>
                    </Column>
                </Row>
                <Table headerRows={1} spacing="small" showStripes={true}>
                    <HeaderRow/>
                    {lmVRIDs.map((item, index) => (
                        <TableRow key={item.LMVRID}>
                            {
                                LMVRID_ATTRIBUTES.map(([a, b], index) => {
                                    if (a === "LAST_UPDATED_BY") {
                                        return (
                                            <TableCell key={index}>{item[a] ? <PhoneTool value={item[a]}/> : ''}</TableCell>
                                        )
                                    } else if(a === "LMVRID") {
                                        return (<TableCell key={index}>{maskLmVRID(item[a])}</TableCell>);
                                    }
                                    return (<TableCell key={index}>{item[a]}</TableCell>);
                                })
                            }
                            <TableCell>
                                <Button size="small" disabled="true" >
                                    <FormattedMessage id="download" defaultMessage="Download"/>
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </Table>
                <Row>
                    {<AppNotification type="error" message={errorMessage} onClose={() => (
                        dispatch({
                            type: EwayBillActions.FETCH_LMVRID_DETAILS,
                            dispatcher: dispatch
                        }))}/>}
                </Row>
            </Box>
            </Column>
        )
    }


    const onClickExportToCSV = () => {
        csvLink.current.link.click()
    }

    const onClickDownload = (lmVRID) => {
        dispatch({
            type: EwayBillActions.DOWNLOAD_EWAYBILL,
            data: { lmVRID:lmVRID},
            dispatcher: dispatch
        })
    }

    return (
        <Column spacingInset="small large">
            <Box>
                <Row width="100%" widths="fill" spacing="medium" spacingInset="medium">
                    <Column>
                        <Text type="h600"><FormattedMessage id="print.lmvrid_details" defaultMessage="LM-VRID Details"/></Text>
                    </Column>
                    <Column>
                        <Row alignmentHorizontal="right">
                            <Button onClick={onClickExportToCSV} disabled={loading} type="tertiary">
                                <FormattedMessage id="print.export_to_csv" defaultMessage="Export to CSV"/></Button>
                            <CSVLink  data={getCSVdata(lmVRIDs)} ref={csvLink} filename={csvFileName} target="_blank" fileEncoding="UTF-8"/>

                        </Row>
                    </Column>
                </Row>
                <Box>
                    <Table headerRows={1} spacing="small" showStripes={true}>
                        <HeaderRow/>
                        {lmVRIDs.map((item, index) => (
                            <TableRow key={item.LMVRID}>
                                {
                                    LMVRID_ATTRIBUTES.map(([a, b], index) => {
                                        if (a === "LAST_UPDATED_BY") {
                                            return (
                                                <TableCell key={index}>{item[a] ? <PhoneTool value={item[a]}/> : ''}</TableCell>
                                            )
                                        } else if(a === "LMVRID") {
                                            return (<TableCell key={index}>{maskLmVRID(item[a])}</TableCell>);
                                        }
                                        return (<TableCell key={index}>{item[a]}</TableCell>);
                                    })
                                }
                                <TableCell>
                                    <Button size="small" onClick={() => onClickDownload(item.LMVRID)}>
                                        <FormattedMessage id="download" defaultMessage="Download"/>
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </Table>
                </Box>
            </Box>
        </Column>
    )
};

function HeaderRow(){
    return <TableRow key={"top"}>
        <TableCell header='true' fontWeight={"fontWeightBold"}><FormattedMessage id="lmvrid" defaultMessage="LM-VRID"/></TableCell>
        <TableCell header='true' fontWeight={"fontWeightBold"}><FormattedMessage id="lastUpdatedBy" defaultMessage="Last Updated By"/></TableCell>
        <TableCell header='true' fontWeight={"fontWeightBold"}><FormattedMessage id="lastUpdatedTime" defaultMessage="Last Updated Time"/></TableCell>
        <TableCell header='true' fontWeight={"fontWeightBold"}><FormattedMessage id="download_ewb" defaultMessage="Download E-way Bill"/></TableCell>
    </TableRow>
}

HeaderRow.WrappedComponent = TableRow;




// WEBPACK FOOTER //
// ./src/components/eWayBill/EwayBill.js